/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgCartIcon: FC<IProps> = ({ width = 24, height = 24, color = "#262626" }) => (
  <svg width={width} height={height} viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.75 0.75H2.41667L4.63333 11.1C4.71465 11.479 4.92556 11.8179 5.22976 12.0582C5.53396 12.2985 5.91242 12.4253 6.3 12.4167H14.45C14.8293 12.4161 15.1971 12.2861 15.4925 12.0482C15.788 11.8103 15.9934 11.4788 16.075 11.1083L17.45 4.91667H3.30833M6.54167 16.5417C6.54167 17.0019 6.16857 17.375 5.70833 17.375C5.2481 17.375 4.875 17.0019 4.875 16.5417C4.875 16.0814 5.2481 15.7083 5.70833 15.7083C6.16857 15.7083 6.54167 16.0814 6.54167 16.5417ZM15.7083 16.5417C15.7083 17.0019 15.3352 17.375 14.875 17.375C14.4148 17.375 14.0417 17.0019 14.0417 16.5417C14.0417 16.0814 14.4148 15.7083 14.875 15.7083C15.3352 15.7083 15.7083 16.0814 15.7083 16.5417Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgCartIcon;
